import { create } from 'zustand';

import type { SimilarReportsState } from '@/screens/SimilarReports/similarReports.types';

type SimilarReportsStore = {
  state: SimilarReportsState | null;
  setState: (nextState: SimilarReportsState | null) => void;
  clear: () => void;
};

export const useSimilarReportsStore = create<SimilarReportsStore>((set) => ({
  state: null,
  setState: (nextState): void => set({ state: nextState }),
  clear: (): void => set({ state: null }),
}));
